"use no memo";

export type Nullable<T> = { [K in keyof T]: T[K] | null };

export function isRecord(input: unknown): input is Record<string, unknown> {
  return input !== null && typeof input === 'object';
}
